import { IRowNode } from 'ag-grid-community';

export function getDateTimeValue(value: Date | string | null | undefined): number {
  if (value == null) return 0;

  const time = new Date(value).getTime();
  return Number.isNaN(time) ? 0 : time;
}

/**
 * Creates an ag-Grid comparator that sorts by raw date values from row data.
 * Use with type="date" columns where valueGetter formats dates for display.
 */
export function createDateFieldComparator<T extends object>(field: keyof T & string) {
  return (
    _valueA: unknown,
    _valueB: unknown,
    nodeA: IRowNode<T>,
    nodeB: IRowNode<T>,
  ) => getDateTimeValue(nodeA.data?.[field] as Date | string | null | undefined)
    - getDateTimeValue(nodeB.data?.[field] as Date | string | null | undefined);
}

export const modifiedDateComparator = createDateFieldComparator<{ modifiedDate: Date | string }>('modifiedDate');
